<template>
    <div class="w-100">
        <v-card-title class="title font-weight-regular justify-space-between">
            {{ title }}
            <v-avatar
                color="primary lighten-2"
                class="subheading white--text"
                size="24"
                v-text="step"
                v-if="step"
            />
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <oss-text-field-filled label="Montant 1" v-model="amount1" />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <oss-text-field-filled label="Montant 2" readonly :model-value="amount2" />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions v-if="!actions">
            <v-btn rounded @click="cancel()" style="margin: center" size="small">{{
                step ? "Précédent" : "Annuler"
            }}</v-btn>
            <v-spacer />
            <v-btn
                rounded
                @click="cut"
                :loading="loading"
                :disabled="disabledValidate()"
                size="small"
                >Valider</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script lang="ts">
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["added", "cancel"],
})
export class CutAccountingLine extends Vue {
    @Prop({ default: null }) step: any;
    @Prop({ default: null }) reconciliationVue: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) btItem: any;
    @Prop({ default: null }) actions: any;

    loading: boolean = false;
    amount1 = 0.0;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get amount2() {
        return this.amountSigned - this.amount1;
    }

    get title() {
        return "Découper le montant " + newCommonFormatCurrency(this.amountSigned);
    }

    get amountSigned() {
        if (this.btItem && this.btItem.accountingLine) {
            return this.btItem.accountingLine.amountSigned;
        }
        return 0.0;
    }

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Valider";
            this.actions.action.disabled = this.disabledValidate;
            this.actions.action.function = this.cut;
            this.actions.action.loading = () => {
                return this.loading;
            };
        }
    }

    disabledValidate() {
        if (!this.amount1) return true;
        return false;
    }

    async cut() {
        this.loading = true;
        if (this.btItem) {
            await this.reconciliationVue.cutBTAccountingLine(
                this.btItem,
                this.amount1,
                this.amount2,
            );
            await this.reconciliationVue.refresh();
            this.amount1 = 0.0;
            this.$emit("added");
        }
        this.loading = false;
    }

    cancel() {
        this.$emit("cancel");
    }
}

export default toNative(CutAccountingLine);
</script>
